<template>
  <div>
    <!-- start: page -->
    <form class="ecommerce-form action-buttons-fixed" @submit.prevent="submitForm">
      <div class="row">
        <div class="col">
          <section class="card card-modern card-big-info">
            <div class="card-body">
              <div class="row">
                <div class="col-lg-2-5 col-xl-1-5">
                  <i class="card-big-info-icon bx bx-slider"></i>
                  <h2 class="card-big-info-title">{{ translations.details }}</h2>
                  <p class="card-big-info-desc">
                    {{ translations.detailsInfo }}
                  </p>
                </div>


                <div class="col-lg-3-5 col-xl-4-5">
                  <div class="form-group row align-items-center mb-3" :class="{ 'has-danger': $v.bank.title.$anyError }">
                    <label class="col-lg-5 col-xl-3 control-label text-lg-end mb-0">
                      {{ translations.forms.labels.title }}
                    </label>
                    <div class="col-lg-7 col-xl-6">
                      <input
                        type="text"
                        class="form-control form-control-modern"
                        :placeholder="translations.forms.labels.title"
                        v-model="bank.title"
                      />

                      <form-error :model="$v.bank.title" :dirty="$v.$dirty" :label="translations.forms.labels.title" />
                    </div>
                  </div>

                  <div class="form-group row align-items-center mb-3" :class="{ 'has-danger': $v.bank.description.$anyError }">
                    <label class="col-lg-5 col-xl-3 control-label text-lg-end mb-0">
                      {{ translations.forms.labels.description }}
                    </label>
                    <div class="col-lg-7 col-xl-6">
                      <textarea class="form-control form-control-modern" v-model="bank.description" :placeholder="translations.forms.labels.description" />

                      <form-error :model="$v.bank.description" :dirty="$v.$dirty" label="Opis" />
                    </div>
                  </div>

                  <div class="form-group row align-items-center mb-3" :class="{ 'has-danger': $v.bank.accountNumber.$anyError }">
                    <label class="col-lg-5 col-xl-3 control-label text-lg-end mb-0">Broj računa</label>
                    <div class="col-lg-7 col-xl-6">
                      <input
                        type="text"
                        class="form-control form-control-modern"
                        placeholder="Broj računa"
                        v-model="bank.accountNumber"
                      />

                      <form-error :model="$v.bank.accountNumber" :dirty="$v.$dirty" label="Broj računa" />
                    </div>
                  </div>

                </div>

              </div>
            </div>
          </section>
        </div>
      </div>
      <div class="action-buttons d-flex justify-content-between">
        <div>
          <button
            type="button"
            data-bs-toggle="modal"
            data-bs-target="#delete-modal"
            class="delete-button btn btn-danger btn-px-4 py-3 d-flex align-items-center font-weight-semibold line-height-1">
            <i class="bx bx-trash text-4 me-2"></i> {{ translations.delete }}
          </button>
        </div>
        <div class="d-flex gap-3">
          <router-link exact :to="{ name: 'Banks' }" class="cancel-button btn btn-light btn-px-4 py-3 border font-weight-semibold text-color-dark text-3">
            {{ translations.cancel }}
          </router-link>
          <button
            type="submit"
            class="
              submit-button
              btn btn-primary btn-px-4
              py-3
              d-flex
              align-items-center
              font-weight-semibold
              line-height-1
            "
            data-loading-text="Loading..."
          >
            <i class="bx bx-save text-4 me-2"></i> {{ translations.save }}
          </button>
        </div>
      </div>
      <modal id="delete-modal">
        <h5 slot="header"><strong>{{ translations.deleteBank }}</strong></h5>
        <div slot="body">
          <span v-html="modalText">
          </span>
        </div>
        <div slot="footer">
          <div class="row">
            <div class="col-md-12 text-end">
              <button type="button" class="btn btn-primary px-4 mx-2" @click.prevent.stop="deleteBank" data-bs-dismiss="modal">
                {{ translations.yes }}
              </button>
              <button type="button" class="btn btn-default px-4" data-bs-dismiss="modal">
                {{ translations.no }}
              </button>
            </div>
          </div>
        </div>
      </modal>
    </form>
    <!-- end: page -->
  </div>
</template>

<script>
import { translations } from '@/mixins';
import validations from './validation-schema/add';
import api from '@/services/api';
import FormError from '../shared/form-errors/FormError.vue';
import Modal from '../shared/modal/Modal.vue';

export default {
  name: 'AddBank',
  components: { FormError, Modal },
  mixins: [translations],
  validations: {
    bank: {
      ...validations
    },
  },
  computed: {
    modalText() {
      return this.translations.areYouSureBank.replace('{bank}', `<strong>${this.bank.title}</strong>`);
    },
    bank() {
      return this.$store.getters.getBank;
    },
    isFormValid() {
      return !this.$v.$invalid;
    },
  },
  mounted() {
    this.$store.dispatch('getBank', this.$route.params.id);
  },
  methods: {
    submitForm() {
      this.$v.$touch();
      if (!this.isFormValid) {
        this.$toast.error(this.translations.forms.notValid);
        return;
      }

      api.updateBank(this.bank)
        .then((response) => {
          this.$toast.info(response.data.info);
          this.$router.push({ name: 'Banks' });
        })
        .catch((err) => {
          this.$toast.error(err?.response?.data?.info || 'Desila se greška');
        });
    },
    deleteBank() {
      api
        .deleteBanks([this.bank.id])
        .then((response) => {
          this.$toast.info(response.data.info);
          this.$router.push({ name: 'Banks' });
        })
        .catch((err) => {
          this.$toast.error(err?.response?.data?.info || 'Desila se greška');
          this.$router.push({ name: 'Banks' });
        });
    },
  },
};
</script>